// Cyber Air Hockey Client
import { sounds } from '../sound.js';

export class AirHockeyGameClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.puck = { x: 400, y: 220, r: 16 };
    this.mallets = {};
    this.scores = { p1: 0, p2: 0 };
    this.players = [];

    this.render();
    this.setupSocketEvents();
    this.setupControls();
  }

  render() {
    this.container.innerHTML = `
      <div class="hockey-wrapper">
        <div class="hockey-header">
          <div class="hockey-scoreboard">
            <span class="score-p1" id="hockey-score-p1">🔴 0</span>
            <span class="score-divider">AIR HOCKEY (RACE TO 7)</span>
            <span class="score-p2" id="hockey-score-p2">0 🔵</span>
          </div>
          <div class="hockey-sub">Move mouse or drag touch on your half of the table to hit the puck!</div>
        </div>

        <div class="hockey-canvas-box">
          <canvas id="hockey-canvas" width="800" height="440"></canvas>
        </div>
      </div>
    `;

    this.canvas = document.getElementById('hockey-canvas');
    this.ctx = this.canvas.getContext('2d');
  }

  setupControls() {
    const handlePaddle = (clientX, clientY) => {
      const rect = this.canvas.getBoundingClientRect();
      const mouseX = (clientX - rect.left) * (this.canvas.width / rect.width);
      const mouseY = (clientY - rect.top) * (this.canvas.height / rect.height);
      this.socket.emit('hockey_paddle', { x: mouseX, y: mouseY });
    };

    this.mouseMoveHandler = (e) => handlePaddle(e.clientX, e.clientY);
    this.touchMoveHandler = (e) => {
      if (e.touches && e.touches[0]) {
        e.preventDefault();
        handlePaddle(e.touches[0].clientX, e.touches[0].clientY);
      }
    };

    this.canvas.addEventListener('mousemove', this.mouseMoveHandler);
    this.canvas.addEventListener('touchmove', this.touchMoveHandler, { passive: false });
    this.canvas.addEventListener('touchstart', this.touchMoveHandler, { passive: false });
  }

  setupSocketEvents() {
    this.socket.on('hockey_started', (data) => {
      this.players = data.players;
      this.mallets = data.mallets;
      this.scores = data.scores;
      sounds.playChime();
      this.draw();
    });

    this.socket.on('hockey_state', (data) => {
      this.puck = data.puck;
      this.mallets = data.mallets;
      this.scores = data.scores;

      const p1Score = document.getElementById('hockey-score-p1');
      const p2Score = document.getElementById('hockey-score-p2');
      if (p1Score) p1Score.innerText = `🔴 ${this.scores.p1}`;
      if (p2Score) p2Score.innerText = `${this.scores.p2} 🔵`;

      this.draw();
    });

    this.socket.on('hockey_goal', (data) => {
      sounds.playVictory();
      this.scores = data.scores;
    });

    this.socket.on('hockey_gameOver', (data) => {
      sounds.playVictory();
      alert(`🏆 AIR HOCKEY CHAMPION: ${data.winner?.name || 'Player'} (${this.scores.p1} - ${this.scores.p2})`);
    });
  }

  draw() {
    if (!this.ctx) return;

    // Neon Table Surface
    this.ctx.fillStyle = '#060b18';
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

    // Neon Outer Border & Rails
    this.ctx.strokeStyle = '#0284c7';
    this.ctx.lineWidth = 12;
    this.ctx.strokeRect(6, 6, this.canvas.width - 12, this.canvas.height - 12);

    // Center Line
    this.ctx.strokeStyle = 'rgba(56, 189, 248, 0.4)';
    this.ctx.lineWidth = 3;
    this.ctx.beginPath();
    this.ctx.moveTo(400, 0);
    this.ctx.lineTo(400, this.canvas.height);
    this.ctx.stroke();

    // Center Circle
    this.ctx.beginPath();
    this.ctx.arc(400, 220, 70, 0, Math.PI * 2);
    this.ctx.stroke();

    // Goal Slots (Left & Right)
    this.ctx.fillStyle = '#ef4444';
    this.ctx.fillRect(0, 140, 12, 160);
    this.ctx.fillStyle = '#38bdf8';
    this.ctx.fillRect(788, 140, 12, 160);

    // Draw Mallets
    for (const id in this.mallets) {
      const m = this.mallets[id];
      this.ctx.fillStyle = m.color;
      this.ctx.shadowColor = m.color;
      this.ctx.shadowBlur = 14;
      this.ctx.beginPath();
      this.ctx.arc(m.x, m.y, m.r, 0, Math.PI * 2);
      this.ctx.fill();

      // Inner Handle
      this.ctx.fillStyle = '#0f172a';
      this.ctx.beginPath();
      this.ctx.arc(m.x, m.y, 10, 0, Math.PI * 2);
      this.ctx.fill();
    }
    this.ctx.shadowBlur = 0;

    // Draw Puck
    this.ctx.fillStyle = '#facc15';
    this.ctx.shadowColor = '#facc15';
    this.ctx.shadowBlur = 16;
    this.ctx.beginPath();
    this.ctx.arc(this.puck.x, this.puck.y, this.puck.r, 0, Math.PI * 2);
    this.ctx.fill();
    this.ctx.shadowBlur = 0;
  }

  destroy() {
    if (this.mouseMoveHandler) this.canvas?.removeEventListener('mousemove', this.mouseMoveHandler);
    this.socket.off('hockey_started');
    this.socket.off('hockey_state');
    this.socket.off('hockey_goal');
    this.socket.off('hockey_gameOver');
  }
}
